/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Info_ExpandInputs */

const vi_vehicle_info_expand = /** @type {(inputs: Vehicle_Info_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở thông tin`)
};

/**

* @param {Vehicle_Info_ExpandInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_info_expand = /** @type {((inputs?: Vehicle_Info_ExpandInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Info_ExpandInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_info_expand(inputs)
});